import { Component, OnInit, ViewChild, Input, Output, EventEmitter, ElementRef } from '@angular/core';
import { AttachmentRest } from './attachments.rest'
import { AttachmentUploadParameter, AttachmentDeleteParameter, AttachmentHolder, AttachmentInfo } from "./attachments.model";
import { GridComponent } from '../grid/grid.component';
import { Subscription } from 'rxjs';
import { MessageBoxComponent } from '../message-box.component';

@Component({
  selector: 'app-attachments',
  templateUrl: './attachments.component.html',
  styleUrls: ['./attachments.component.scss']
})
export class AttachmentsComponent implements OnInit {

  constructor(private attachmentRest: AttachmentRest) { }

  @ViewChild(GridComponent) grid: GridComponent;
  @ViewChild(MessageBoxComponent) messageBox: MessageBoxComponent;
  @ViewChild('file') fileInput: ElementRef;

  private objectTypeId: number;
  private objectId: number;
  public attachment: File;
  public selectedFile: string = 'Nie wybrano pliku';
  public path: string;
  @Input() public isEditable = true;
  @Input() public isRemovable = true;
  @Input() public allowAdding = true;
  @Input() public sortable = false;
  @Input() public controller: string;
  @Input() public attachments: AttachmentInfo[];
  @Output() public attachmentsChange: EventEmitter<AttachmentInfo[]> = new EventEmitter();
  private messageBoxSubscription: Subscription;
  private attachmentHolder: AttachmentHolder;
  private headers = [
    { displayName: 'Nazwa', propertyName: 'name', propertyType: 'string' },
    { displayName: 'Rozszerzenie', propertyName: 'extension', propertyType: 'string' },
    { displayName: 'Rozmiar', propertyName: 'size', propertyType: 'string' },
    { displayName: 'Data utworzenia', propertyName: 'createDate', propertyType: 'date', dateFormat: 'dd.MM.yyyy HH:mm' }
  ];

  ngOnInit() { }

  public getAttachments() {
    return this.attachments;
  }

  public uploadFile() {
    var reader = new FileReader();

    if (this.attachment == null)
      return;

    if ((this.attachment as File).size > 12582912) {
      sweetAlert("Wielkość pliku nie może przekraczać 12 MB");
      return;
    }    

    reader.readAsArrayBuffer(this.attachment);
    reader.onload = () => {
      let parameter = new AttachmentUploadParameter();
      parameter.objectTypeId = this.objectTypeId;
      parameter.file = this.convertToBase64(reader.result as ArrayBuffer);
      parameter.fileName = `${this.getNormalizedFilename(this.attachment.name)}${this.getFileExtension(this.attachment.name)}`;
      parameter.objectId = this.objectId;
      parameter.controller = this.controller
      this.attachmentRest.checkFileNames(this.controller, this.attachment.name, this.objectTypeId, this.objectId).subscribe((res: boolean) => {
        if (res) {
          sweetAlert(`Plik o podanej nazwie już istnieje. Czy na pewno chcesz zapisać?`, {
            buttons: {
              yes: {
                text: "Tak",
                value: "yes"
              },
              no: {
                text: "Nie",
                value: "no",
              }
            }
          })
            .then((value) => {
              switch (value) {
                case "yes":
                  this.attachmentRest.addAttachmentAndGetMetadata(parameter).subscribe((res: AttachmentInfo) => {
                    this.attachments.push(res);
                    sweetAlert({ text: `Plik "${res.name}" został zapisany` });
                    this.grid.refreshData();
                    this.fileInput.nativeElement.value = "";
                    this.attachmentsChange.emit(this.attachments);
                  });
              }
            });
          this.fileInput.nativeElement.value = "";
        }
        else {
          this.attachmentRest.addAttachmentAndGetMetadata(parameter).subscribe((res: AttachmentInfo) => {
            this.attachments.push(res);
            sweetAlert({ text: `Plik "${res.name}" został zapisany` });
            this.grid.refreshData();
            this.fileInput.nativeElement.value = "";
            this.attachmentsChange.emit(this.attachments);
          });
        }
      });
    }
  }

  public onFileChanged(files: File[]) {
    if (!files)
      return;

    this.attachment = files[0];
    this.selectedFile = files[0].name;
    if (this.objectId !== 0)
      this.uploadFile();
    else {
      if (this.attachment == null)
        return;
      if (this.attachments.some(x => x.name === this.attachment.name)) {
        sweetAlert(`Plik o podanej nazwie już istnieje. Czy na pewno chcesz zapisać?`, {
          buttons: {
            yes: {
              text: "Tak",
              value: "yes"
            },
            no: {
              text: "Nie",
              value: "no",
            }
          }
        })
          .then((value) => {
            switch (value) {
              case "yes":
                this.addNewAttachment();
            }
          });
        this.fileInput.nativeElement.value = "";
      }
      else {
        this.addNewAttachment();
      }
    }
  }

  // public setModel(objectTypeId : number, objectId: number, controller: string){
  public setModel(attachmentHolder: AttachmentHolder, controller: string) {
    this.attachmentHolder = attachmentHolder;
    this.objectId = attachmentHolder.id;
    this.objectTypeId = attachmentHolder.objectTypeId;
    this.controller = controller;
    this.attachments = this.attachmentHolder.attachments;
  };

  public onMessageBoxClose() {
    if (this.messageBoxSubscription) {
      this.messageBoxSubscription.unsubscribe();
    }
  }

  private onRowEdit(row: any) {
    this.getFile(row.id);
  }

  private onRowDelete(row: any) {
    sweetAlert(`Czy usunąć załącznik "${row.name}"?`, {
      buttons: {
        yes: {
          text: "Tak",
          value: "yes"
        },
        no: {
          text: "Nie",
          value: "no",
        }
      }
    })
      .then((value) => {
        switch (value) {
          case "yes":
            if (row.id > 0) {
              let action = this.attachmentRest.delete;
              let paramter = new AttachmentDeleteParameter();
              paramter.attachmentId = row.id;
              paramter.controller = this.controller;
              action.call(this.attachmentRest, paramter).subscribe(res => {
                sweetAlert(`Plik ${row.name} został usunięty`);
                this.attachments.splice(this.attachments.indexOf(row), 1);
                this.grid.refreshData();
                this.attachmentsChange.emit(this.attachments);
              });
            }
            else {
              sweetAlert(`Plik ${row.name} został usunięty`);
              this.attachments.splice(this.attachments.indexOf(row), 1);
              this.grid.refreshData();
              this.attachmentsChange.emit(this.attachments);
            }
            break;
        }
      });

  }
  private onActivate(event) { return }
  private getActionButtons() {
    return [];
  }

  getFile(attachmentId: number) {
    if (this.objectId !== 0) {
      return this.attachmentRest.get(attachmentId, this.controller).subscribe(res => {
        let byteArray = this.convertFromBase64(res.content);
        let blob = new Blob([byteArray], { type: res.contentType });
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = res.fileName;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      });
    }
    else {
      let attachment = this.attachments.find(x => x.id === attachmentId);
      let byteArray = this.convertFromBase64(attachment.fileString);
      let blob = new Blob([byteArray], { type: attachment.contentType });
      var url = window.URL.createObjectURL(blob);
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.setAttribute('style', 'display: none');
      a.href = url;
      a.download = attachment.name;
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
    }
  }

  private convertToBase64(arrayBuffer: ArrayBuffer) {
    let binaryString = ''
    let array = new Uint8Array(arrayBuffer);
    for (var i = 0; i < array.byteLength; i++) {
      binaryString += String.fromCharCode(array[i]);
    }
    return window.btoa(binaryString);
  }

  private convertFromBase64(base64: string) {
    var byteCharacters = atob(base64);
    var byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    return new Uint8Array(byteNumbers);
  }

  private getNormalizedFilename(name: string) {
    let filename = name.substring(0, this.attachment.name.lastIndexOf('.'));
    let extension = name.substring(this.attachment.name.lastIndexOf('.'));
    filename = filename.replace(/\.\//g, "_");
    //filename += extension;
    return filename;
  }

  private getFileExtension(name: string) {
    let extension = name.substring(name.lastIndexOf('.'));
    return extension;
  }

  private getName(name: string) {
    let numberOfCopies: number = 0;
    let i: number = 0;

    while (i < this.attachments.length) {
      if (this.attachments[i].name === name) {
        numberOfCopies++;
        name = `${this.getNormalizedFilename(name)} (${numberOfCopies})${this.getFileExtension(name)}`;
        i = 0;
      }
      else {
        i++;
      }
    }
    return name;
  }

  private addNewAttachment() {
    var reader = new FileReader();
    reader.readAsArrayBuffer(this.attachment);
    reader.onload = () => {
      let attachment = new AttachmentInfo();
      attachment.createdDate = new Date();
      attachment.extension = this.getFileExtension(this.attachment.name);
      attachment.name = `${this.getNormalizedFilename(this.attachment.name)}${this.getFileExtension(this.attachment.name)}`; //this.getName(this.attachment.name);
      attachment.id = (this.attachments.length !== 0 ? Math.min.apply(Math, this.attachments.map(function (o) { return o.id; })) : 0) - 1;
      attachment.size = `${this.convertBytesToKilobytes(this.attachment.size).toFixed(2)} KB`;
      attachment.contentType = this.attachment.type;
      attachment.fileString = this.convertToBase64(reader.result as ArrayBuffer);
      this.attachments.push(attachment);
      sweetAlert({ text: `Plik "${attachment.name}" został zapisany` });
      this.grid.refreshData();
      this.fileInput.nativeElement.value = "";
      this.attachmentsChange.emit(this.attachments);
    }
  }

  private convertBytesToKilobytes(bytes: number)
  {
      return bytes / 1024;
  }
}